import React from 'react';
import { useLoaderData } from 'react-router-dom';
import { Alumni, API } from '@enrich/shared-lib';
import QueryString from 'qs';

export const SchoolAlumniStudents = () => {
    const school = useLoaderData();

    return (
        <Alumni
            schoolId={school.id}
            backHref={`/schools/${school.id}`}
            backLabel={school.attributes?.name || 'School'}
        />
    );
};

export async function loader({ params }) {
    const query = QueryString.stringify({
        fields: ['id', 'name'],
    });

    try {
        const response = await API.get(
            `/api/schools/${params.schoolId}?${query}`,
        );
        return response.data.data;
    } catch (error) {
        console.log(error);
        return {};
    }
}
